import { theme } from 'styles/theme/hav-theme'

import {
  AltRoute,
  Archive,
  ArrowFoward,
  ArrowLeft,
  ArrowRight,
  BarChart,
  Batch,
  Bell,
  Bot,
  Box,
  BrazilFlag,
  Budget,
  Calendar,
  CalendarClock,
  CalendarDays,
  CalendarPlus,
  Cancel,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  ChevronUp,
  CircleCheck,
  CirclePercent,
  ClearAll,
  Clock,
  Close,
  Consult,
  Copy,
  CopyCheck,
  DateTransfer,
  Download,
  EDI,
  Edit,
  Ellipsis,
  Email,
  Empty,
  Eraser,
  Error,
  Expand,
  ExternalLink,
  Factory,
  Feet,
  File,
  FileChartColumn,
  FileCog,
  FileInput,
  FileSpreadsheet,
  FileUp,
  Filter,
  Gift,
  GiveBack,
  HC,
  Headset,
  History,
  HomeOutlined,
  HomeRounded,
  House,
  Info,
  Less,
  List,
  Loader,
  Loading,
  Logout,
  Megaphone,
  Menu,
  MissingPiece,
  Money,
  More,
  ND,
  Note,
  Notification,
  NotificationOff,
  Package,
  Palette,
  PapperClip,
  Pencil,
  Percent,
  PhoneInTalk,
  Placeholder,
  Plus,
  PostAdd,
  PostOff,
  PostOn,
  Profile,
  RefreshCW,
  Report,
  RequestQuote,
  Sandal,
  Save,
  Search,
  SearchOff,
  Send,
  Share,
  ShieldCheck,
  Smartphone,
  Sort,
  SpainFlag,
  Star,
  Sticky,
  Swap,
  Sync,
  SyncProplem,
  Table,
  TableProperties,
  Tag,
  TaskAlt,
  Track,
  Trash,
  Trash2,
  TrendingUp,
  TriangleAlert,
  UkFlag,
  Undo,
  Upload,
  UserStar,
  Visibility,
  VisibilityOff,
  WalletCard,
} from './AllIcons'

export const icons = {
  'alt-route': AltRoute,
  archive: Archive,
  'arrow-forward': ArrowFoward,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'bar-chart': BarChart,
  batch: Batch,
  bell: Bell,
  bot: Bot,
  box: Box,
  'brazil-flag': BrazilFlag,
  budget: Budget,
  calendar: Calendar,
  'calendar-clock': CalendarClock,
  'calendar-days': CalendarDays,
  'calendar-plus': CalendarPlus,
  cancel: Cancel,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'chevrons-left': ChevronsLeft,
  'chevrons-right': ChevronsRight,
  'circle-check': CircleCheck,
  'circle-percent': CirclePercent,
  'clear-all': ClearAll,
  clock: Clock,
  close: Close,
  consult: Consult,
  copy: Copy,
  'copy-check': CopyCheck,
  'date-transfer': DateTransfer,
  download: Download,
  edi: EDI,
  edit: Edit,
  ellipsis: Ellipsis,
  email: Email,
  empty: Empty,
  eraser: Eraser,
  error: Error,
  expand: Expand,
  'external-link': ExternalLink,
  factory: Factory,
  feet: Feet,
  file: File,
  'file-chart-column': FileChartColumn,
  'file-cog': FileCog,
  'file-input': FileInput,
  'file-spreadsheet': FileSpreadsheet,
  'file-up': FileUp,
  filter: Filter,
  gift: Gift,
  'give-back': GiveBack,
  hc: HC,
  headset: Headset,
  history: History,
  'home-outlined': HomeOutlined,
  'home-rounded': HomeRounded,
  house: House,
  info: Info,
  less: Less,
  list: List,
  loader: Loader,
  loading: Loading,
  logout: Logout,
  megaphone: Megaphone,
  menu: Menu,
  'missing-piece': MissingPiece,
  money: Money,
  more: More,
  nd: ND,
  note: Note,
  notification: Notification,
  'notification-off': NotificationOff,
  package: Package,
  palette: Palette,
  'paper-clip': PapperClip,
  pencil: Pencil,
  percent: Percent,
  'phone-in-talk': PhoneInTalk,
  placeholder: Placeholder,
  plus: Plus,
  'post-add': PostAdd,
  'post-off': PostOff,
  'post-on': PostOn,
  profile: Profile,
  'refresh-cw': RefreshCW,
  report: Report,
  'request-quote': RequestQuote,
  sandal: Sandal,
  save: Save,
  search: Search,
  'search-off': SearchOff,
  send: Send,
  share: Share,
  'shield-check': ShieldCheck,
  smartphone: Smartphone,
  sort: Sort,
  'spain-flag': SpainFlag,
  star: Star,
  sticky: Sticky,
  swap: Swap,
  sync: Sync,
  'sync-problem': SyncProplem,
  table: Table,
  'table-properties': TableProperties,
  tag: Tag,
  'task-alt': TaskAlt,
  track: Track,
  trash: Trash,
  'trash-2': Trash2,
  'trending-up': TrendingUp,
  'triangle-alert': TriangleAlert,
  'uk-flag': UkFlag,
  undo: Undo,
  upload: Upload,
  'user-star': UserStar,
  visibility: Visibility,
  'visibility-off': VisibilityOff,
  'wallet-card': WalletCard,
}

export const ICON_DEFAULT_SIZE = '50'
export const ICON_DEFAULT_VIEWBOX = '0 0 50 50'
export const ICON_DEFAULT_COLOR = theme.colors.neutral[90]
export const ICON_DEFAULT_DISABLED_COLOR = theme.colors.neutral.lighthover
export const ICON_DEFAULT_FILL = 'none'
export const ICON_DEFAULT_WIDTH = ICON_DEFAULT_SIZE
export const ICON_DEFAULT_HEIGHT = ICON_DEFAULT_SIZE

export type IconName = keyof typeof icons

export type IconProps = {
  icon: IconName
  color?: string
  fill?: string
  width?: string
  height?: string
  size?: string
  viewBox?: string
}

export const Icon = ({ icon, color, fill, size, viewBox, ...props }: IconProps) => {
  const IconComponent = icons[icon]

  return (
    <IconComponent
      color={color}
      fill={fill}
      viewBox={viewBox}
      {...(size ? { height: size, width: size } : {})}
      {...props}
    />
  )
}
